export function getFilenameFromContentDisposition(contentDisposition: string | null): string | null {
    if (!contentDisposition) {
        return null;
    }

    const matches = /filename="([^"]+)"/.exec(contentDisposition);
    return matches ? matches[1] : null;
}
